import React, { useMemo } from 'react';
import MaterialTable from 'material-table';
import { withStyles, Typography } from '@material-ui/core';
import { localization, hasPermission } from '../../../sc-utilities';
import * as action from '../../../np-core/Auth/store/authActions';
import { connect } from 'react-redux';
import Toolbar from '../../../sc-utilities/Toolbar';
import Export from '../../../sc-components/ExportForm';
import * as Yup from "yup";

const styles = () => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        }
    },
    tableTitle: {
        marginTop: '15%',
        display: 'block',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible'
    }
});

let initialValues = [
    'Excel',
    'JSON',
    'CSV',
    'XML',
    'Download',
    "Email",
    "includePDFReports",
    "includeDiagnoseReports",
    "includeVerificationReports",
    "includeAggregatedPDFErasureReports",
    "includeAggregatedPDFVerificationReports",
    "includeSummaryPDFErasureReports",
    "includeSummaryPDFVerificationReports",
];

const route = 'searched';

const ProductsList = props => {
    const { classes, translations, saveColumnsFilter, fetching, tableColumns, activeCustomerID, tableRef, permissions, fetchTableData, tableOptions } = props;

    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []);

    const hasReportDownloadPermission = hasPermission(permissions, 'erasure_report_download');

    const columnHidden = newColumnState => {
        let objToSendColumn = {};
        let objColumns = {};
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden;
            return objColumns;
        });
        objToSendColumn[`Products`] = objColumns;
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID });
        return newColumnState;
    };

    let formSettings = {
        Validation: initialValues.reduce((o, k) => ({ ...o, [k]: Yup.boolean() }), {}),
        ButtonSubmit: hasReportDownloadPermission ? {
            Title: translations["download"] || "Download",
            Color: 'primary'
        } : null
    };

    const tableTitle = () => {
        return <div className={classes.tableTitle}>
            <Typography className={classes.typography}>{translations["assets"] || 'Assets'}</Typography><br />
            {
                hasReportDownloadPermission ?
                    <Export
                        route={route}
                        tableRef={tableRef}
                        initialValues={initialValues}
                        formSettings={formSettings}
                        showProductOverviewExportTypes={true}
                        showProductOverviewOutputMode={true}
                        exportIconTooltip={true}
                        fromSearchList={true}
                    />
                     : null
            }
        </div>
    };

    return (<>
        <MaterialTable
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            components={{
                Toolbar: props => (
                    <Toolbar data={props} selectedRows={props.selectedRows} translations={translations} />
                )
            }}
            isLoading={fetching}
            localization={localization(translations)}
            onChangeColumnHidden={columnHidden}
            onChangePage={() => { if (tableRef?.current?.tableContainerDiv?.current) { tableRef.current.tableContainerDiv.current.scrollTop = 0 } }}
        />
    </>);
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        fetching: state.statistic.searches.fetching,
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ProductsList));